import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Icon,
  DatePicker,
  Input,
  Table,
  Select,
  Button,
  Tag,
  Radio,
  Timeline,
  Spin,
  message,
  Popconfirm,
  Tooltip
} from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "axios";
import Pagination from "../../components/pagination";
import Stats from "./parts/vonboard/stats";
import AgencyModal from "./parts/vonboard/dedicated-agency-modal";
import { Translate } from "react-translated";
import SetupAppointment from "../LandingPage/parts/setup-appointment-modal-vo";
import Collapse from "../../Collapse";
import ShowHideStats from "./parts/show-hide-stats";
import { API_DATE_FORMAT, debounceQuery, get_label_from_value } from "../../utils/Constants";
import {
  ASC,
  DESC,
  SORT_ORDER_ASCEND,
  SORT_ORDER_DESCEND
} from "../../utils/Constants";

const Option = Select.Option;
const { RangePicker } = DatePicker;
const today = new Date();
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class Vonboard extends Component {
  state = {
    loading: false,
    typeOfCall: null,
    period: "all_bfiles",
    start_date: null,
    end_date: null,
    buckets: [
      {
        index: 0,
        direction: DESC,
        order_by: 'expiration_date',
        title: "My Claimed Calls",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {
          search:
            "vo_box1_search" in window.localStorage
              ? window.localStorage.vo_box1_search
              : "",
          agency:
            "vo_box1_agency" in window.localStorage
              ? window.localStorage.vo_box1_agency
              : ""
        }
      },
      {
        index: 1,
        direction: DESC,
        order_by: 'expiration_date',
        title: "Due Calls",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {
          search:
            "vo_box2_search" in window.localStorage
              ? window.localStorage.vo_box2_search
              : "",
          agency:
            "vo_box2_agency" in window.localStorage
              ? window.localStorage.vo_box2_agency
              : ""
        }
      },
      {
        index: 2,
        direction: DESC,
        order_by: 'expiration_date',
        title: "Active Calls",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {
          search:
            "vo_box3_search" in window.localStorage
              ? window.localStorage.vo_box3_search
              : "",
          agency:
            "vo_box3_agency" in window.localStorage
              ? window.localStorage.vo_box3_agency
              : ""
        }
      },
      {
        index: 4,
        direction: DESC,
        order_by: 'expiration_date',
        title: "Upcoming Calls",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {
          search:
            "vo_box5_search" in window.localStorage
              ? window.localStorage.vo_box5_search
              : "",
          agency:
            "vo_box5_agency" in window.localStorage
              ? window.localStorage.vo_box5_agency
              : ""
        }
      },
      {
        index: 7,
        direction: DESC,
        order_by: 'von_appointment_date',
        title: "Appointments Scheduled",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {
          search:
            "vo_box8_search" in window.localStorage
              ? window.localStorage.vo_box8_search
              : "",
          agency:
            "vo_box8_agency" in window.localStorage
              ? window.localStorage.vo_box8_agency
              : ""
        }
      },
      {
        index: 8,
        direction: DESC,
        order_by: 'von_appointment_date',
        title: "Requested To Be Re-Scheduled",
        calls: [],
        loading: false,
        page: 1,
        total_pages: 0,
        filters: {

          search:
            "rs_box9_search" in window.localStorage
              ? window.localStorage.rs_box9_search
              : "",
          agency:
            "rs_box9_agency" in window.localStorage
              ? window.localStorage.rs_box9_agency
              : ""
        }
      }
     
      // {
      //   index: 3,
      //   title: "Calendar Invites",
      //   calls: [],
      //   loading: false,
      //   page: 1,
      //   total_pages: 0,
      //   filters: {
      //     search:
      //       "vo_box4_search" in window.localStorage
      //         ? window.localStorage.vo_box4_search
      //         : "",
      //     agency:
      //       "vo_box4_agency" in window.localStorage
      //         ? window.localStorage.vo_box4_agency
      //         : "",
      //   },
      // },
     
      // {
      //   index: 5,
      //   title: "Completed Calls",
      //   calls: [],
      //   loading: false,
      //   page: 1,
      //   total_pages: 0,
      //   filters: {
      //     search:
      //       "vo_box6_search" in window.localStorage
      //         ? window.localStorage.vo_box6_search
      //         : "",
      //     agency:
      //       "vo_box6_agency" in window.localStorage
      //         ? window.localStorage.vo_box6_agency
      //         : "",
      //   },
      // },
      // {
      //   index: 6,
      //   title: "Not Reached Archived",
      //   calls: [],
      //   loading: false,
      //   page: 1,
      //   total_pages: 0,
      //   filters: {
      //     search:
      //       "vo_box7_search" in window.localStorage
      //         ? window.localStorage.vo_box7_search
      //         : "",
      //     agency:
      //       "vo_box7_agency" in window.localStorage
      //         ? window.localStorage.vo_box7_agency
      //         : "",
      //   },
      // },
      
      // {
      //   index: 8,
      //   title: "Not Interested",
      //   calls: [],
      //   loading: false,
      //   page: 1,
      //   total_pages: 0,
      //   filters: {
      //     search:
      //       "vo_box9_search" in window.localStorage
      //         ? window.localStorage.vo_box9_search
      //         : "",
      //     agency:
      //       "vo_box9_agency" in window.localStorage
      //         ? window.localStorage.vo_box9_agency
      //         : "",
      //   },
      // },
    ],
    agency_id: null,
    user: this.props.auth.user,
    agencies: [],
    stats: {},
    stats_loading: false,
    dedicated_agency_modal: false,
    setup_appointment_modal: false,
    bfile: null
    // bucketsToggle: [
    //   { expandStats: false },
    //   { expandStats: false },
    //   { expandStats: false },
    // ],
  };

  call_vo_agancies = () => {
    axios.get("/api/vo_agencies").then((res) => {
      this.setState({
        agencies: res.data
      });
    });
  }

  componentDidMount = () => {
    this.call_vo_agancies();

    // Default Select `All B Files`
    const data = F.getServerDateByType("all_bfiles");
    window.localStorage.user_start_date = data.from;
    window.localStorage.user_end_date = data.to;
    window.localStorage.user_period = "all_bfiles";

    // OLD Code
    // window.localStorage.vo_agency_id = "";

    /************** New Code START ***************/

    const globalAgencyID =
      "vo_agency_id" in window.localStorage && window.localStorage.vo_agency_id !== ""
        ? parseInt(window.localStorage.vo_agency_id)
        : null;

    // Get sorting direction from local storage
    const sorting_direction = "sorting_direction" in window.localStorage
      ? JSON.parse(window.localStorage.sorting_direction)
      : {};

    // Update state using callback
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map((bucket) => {
        // Update agency filter if globalAgencyID exists
        const updatedFilters = globalAgencyID
          ? { ...bucket.filters, agency: globalAgencyID }
          : bucket.filters;

        // Update sorting direction from local storage
        const updatedDirection = sorting_direction.hasOwnProperty(bucket.index)
          ? sorting_direction[bucket.index]
          : bucket.direction;

        return {
          ...bucket,
          filters: updatedFilters,
          direction: updatedDirection
        };
      });

      return { buckets: newBuckets };
    }, () => {
      this.loadBuckets("all", 1);
      this.loadStats();
    });
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      "action" in this.props.match.params &&
      this.props.match.params.action === "select-agency" &&
      prevState.dedicated_agency_modal === false &&
      this.state.setup_appointment_modal === false
    ) {
      this.setState({ dedicated_agency_modal: true });
    }
  }
  changePeriod = (e) => {
    const value = e.target.value;

    const data = F.getServerDateByType(value);

    // start date
    let start_date = data.from;

    // end date
    let end_date = data.to;

    window.localStorage.user_start_date = start_date;
    window.localStorage.user_end_date = end_date;
    window.localStorage.user_period = value;

    this.setState(
      {
        start_date: start_date,
        end_date: end_date,
        period: value
      },
      () => {
        this.loadBuckets("all", 1);
        this.loadStats();
      }
    );
  };

  handleTypeOfCall = (e) => {
    const value = e.target.value;
    this.setState({ typeOfCall: value }, () => {
      this.loadBuckets("all", 1);
      this.loadStats();
    })
  }

  search = (ind, search) => {
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map((bucket) => {
        if (bucket.index === ind) {
          return {
            ...bucket,
            loading: true,
            filters: {
              ...bucket.filters,
              search: search
            }
          };
        }
        return bucket;
      });
      return { buckets: newBuckets };
    }, () => {
      this.loadBuckets(ind, 1);
    });
  };
  agencyChange = (ind, agency_id) => {
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map((bucket) => {
        if (bucket.index === ind) {
          return {
            ...bucket,
            loading: true,
            filters: {
              ...bucket.filters,
              agency: agency_id
            }
          };
        }
        return bucket;
      });
      return { buckets: newBuckets };
    }, () => {
      this.props.history.push("/dashboard");
      this.loadBuckets(ind, 1);
    });
  };
  onChangeDateRange = (date, dateString) => {
    let start_date = null;
    let end_date = null;
    let period = null;

    // Check If User pressed on `crossed` icon `Reset to Monthly View`
    if (dateString[0].length === 0 && dateString[1].length === 0) {
      start_date = moment(
        new Date(today.getFullYear(), today.getMonth(), 1)
      ).format("YYYY-MM-DD");

      // end date
      end_date = moment(
        new Date(today.getFullYear(), today.getMonth() + 1, 0)
      ).format("YYYY-MM-DD");

      period = "mtd";
    } else {
      start_date = dateString[0];
      end_date = dateString[1];
      period = "from_to";
    }

    window.localStorage.user_start_date = start_date;
    window.localStorage.user_end_date = end_date;
    window.localStorage.user_period = period;

    this.setState(
      {
        start_date,
        end_date,
        period
      },
      () => {
        this.loadBuckets("all", 1);
        this.loadStats();
      }
    );
  };
  refresh = () => {
    this.setState({ loading: true, typeOfCall: null });
    axios.get("/api/delete_user_cache").then((res) => {
      this.setState({
        loading: false,
        period: "all_bfiles",
        start_date: null,
        end_date: null,
      });
      this.call_vo_agancies()
      this.loadBuckets("all", 1);
      this.loadStats();
    });
  };
  loadStats = () => {
    const { agency_id, user, period, start_date, end_date } = this.state;

    let from = null;
    let to = null;

    // for custom range
    if (start_date != null && end_date != null) {
      from = start_date;
      to = end_date;
    }

    if (period != null && period != "from_to") {
      const datesData = F.getServerDateByType(period);
      from = datesData.from;
      to = datesData.to;
    }

    const globalAgencyID =
      "vo_agency_id" in window.localStorage &&
        window.localStorage.vo_agency_id !== ""
        ? parseInt(window.localStorage.vo_agency_id)
        : null;

    let url = "/api/user_vonboard_stats";
    if (globalAgencyID) {
      url = "/api/user_vonboard_stats?agency_id=" + globalAgencyID;
    }

    this.setState({ stats_loading: true });

    axios
      .post(url, {
        user: user.id,
        from,
        to
      })
      .then((res) => {
        this.setState({
          stats: res.data,
          stats_loading: false
        });
      });
  };
  loadBuckets = (sec, page) => {
    const { user, typeOfCall } = this.state;
    const today = moment(new Date()).format("YYYY-MM-DD");
    let callType = typeOfCall === null ? {} : typeOfCall === "prospect" ? { "name": "type_of_call", "op": "==", "val": "Prospect" } : { "name": "type_of_call", "op": "==", "val": "FollowUp" }

    if (sec === "all" || sec === 0) {
      F.log("loadBucket calling 0 ");
      this.loadBucket(
        0,
        "my_vonboard_bfiles",
        JSON.stringify(callType) + ", " +
        '{"name":"vob_attempted","op":"is_null"},{"name":"vob_completed","op":"is_null"},{"name":"vob_archived","op":"is_null"},{"name":"onboarding_id","op":"==","val":"' +
        user.id +
        '"},{"name":"expiration_date","op":">","val":"' +
        today +
        '"}',
        page
      );
    }

    //  Due Calls
    if (sec === "all" || sec === 1) {
      F.log("loadBucket calling 1 ");
      this.loadBucket(
        1,
        "b_file",
        JSON.stringify(callType) + ", " + '{"name":"vob_archived","op":"is_null"},{"name":"vob_attempted","op":"is_null"},{"name":"vob_completed","op":"is_null"},{"or":[{"name":"onboarding_user","op":"is_null"},{"name":"onboarding_user","op":"has","val":{"name":"user_type","op":"!=","val":"VONBOARDER"}}]},{"name":"rs_effective_date","op":"<=","val":"' +
        today +
        '"},{"name":"expiration_date","op":">","val":"' +
        today +
        '"}',
        // '{"name":"vob_archived","op":"is_null"},{"name":"vob_attempted","op":"is_null"},{"name":"vob_completed","op":"is_null"},{"or":[{"name":"onboarding_user","op":"is_null"},{"name":"onboarding_user","op":"has","val":{"name":"user_type","op":"!=","val":"VONBOARDER"}}]}',
        // '{"name":"onboarding_user","op":"is_null"},{"name":"onboarding_user","op":"has","val":{"name":"user_type","op":"!=","val":"VONBOARDER"}}',
        page
      );
    }
    if (sec === "all" || sec == 2) {
      this.loadBucket(
        2,
        "my_vonboard_bfiles",
        JSON.stringify(callType) + ", " +
        '{"or":[{"name":"bfile_folow_up_completed","op":"is_null"},{"name":"bfile_folow_up_completed","op":"==","val":0}]},{"name":"vob_attempted","op":"==","val":1},{"name":"vob_completed","op":"is_null"},{"name":"vob_archived","op":"is_null"},{"name":"onboarding_id","op":"==","val":"' +
        user.id +
        '"},{"name":"expiration_date","op":">","val":"' +
        today +
        '"}',
        page
      );
    }

    // Upcoming
    if (sec === "all" || sec == 4) {
      // New Task Condition -> Customer show on queue only when It's attempted max 5 times
      const not_reached_5_attempts = {
        or: [
          { name: "vob_attempted", op: "is_null" },
          { name: "vob_attempted", op: "<=", val: 5 }
        ]
      };
      // New Task Condition -> Customer show on queue only from the effective date
      const effective_date_condition = {
        or: [
          { name: "rs_effective_date", op: "is_null" },
          { name: "rs_effective_date", op: ">", val: today }
        ]
      };
      this.loadBucket(
        4,
        "b_file",
        JSON.stringify(callType) +
        ", " +
        JSON.stringify(not_reached_5_attempts) +
        ", " +
        JSON.stringify(effective_date_condition) +
        ' ,{"or":[{"name":"vob_completed","op":"!=","val":1},{"name":"vob_completed","op":"is_null"}]},{"or":[{"name":"onboarding_user","op":"is_null"},{"name":"onboarding_user","op":"has","val":{"name":"user_type","op":"!=","val":"VONBOARDER"}}]},{"name":"expiration_date","op":">","val":"' +
        today +
        '"}',
        page
      );
    }
    // if (sec === "all" || sec == 5) {
    //   this.loadBucket(
    //     5,
    //     "my_vonboard_bfiles",
    //     '{"name":"vob_completed","op":"==","val":1},{"name":"vob_archived","op":"is_null"},{"name":"onboarding_id","op":"==","val":"' +
    //       user.id +
    //       '"}',
    //     page
    //   );
    // }
    // if (sec === "all" || sec == 6) {
    //   this.loadBucket(
    //     6,
    //     "my_vonboard_bfiles",
    //     '{"name":"vob_archived","op":"==","val":1},{"name":"vob_attempted","op":"is_null"},{"name":"onboarding_id","op":"==","val":"' +
    //       user.id +
    //       '"}',
    //     page
    //   );
    // }
    if (sec === "all" || sec === 7) {
      F.log("loadBucket calling 7 ");
      this.loadBucket(
        7,
        "my_vonboard_bfiles",
        JSON.stringify(callType) + ", " +
        '{"name":"vob_completed","op":"==","val":1},{"name":"vob_archived","op":"is_null"},{"name":"onboarding_id","op":"==","val":"' +
        user.id +
        '"},{"name":"financial_id","op":"is_not_null"},{"name":"von_appointment_date","op":"is_not_null"},{"name":"expiration_date","op":">","val":"' +
        today +
        '"}',
        page
      );
    }
    // if (sec === "all" || sec == 8) {
    //   this.loadBucket(
    //     8,
    //     "my_vonboard_bfiles",
    //     '{"name":"vob_archived","op":"==","val":1},{"name":"onboarding_id","op":"==","val":"' +
    //       user.id +
    //       '"},{"name":"vob_attempted","op":"==","val":1}',
    //     page
    //   );
    // }
    if (sec === "all" || sec == 8) {
      this.loadBucket(
        8,
        "my_vonboard_bfiles",
        JSON.stringify(callType) + ", " +
        // '{"name":"reschedule_appointment_vo","op":"==","val":1},{"name":"vob_completed","op":"==","val":1},{"name":"vob_archived","op":"is_null"},{"name":"onboarding_id","op":"==","val":"' +
        //   user.id +
        //   '"},{"name":"financial_id","op":"is_not_null"},{"name":"von_appointment_date","op":"is_not_null"}',
        '{"name":"reschedule_appointment_vo","op":"==","val":1},{"name":"vob_completed","op":"==","val":1},{"name":"vob_archived","op":"is_null"},{"name":"financial_id","op":"is_not_null"},{"name":"von_appointment_date","op":"is_not_null"},{"name":"expiration_date","op":">","val":"' +
        today +
        '"}',
        page
      );
    }
  };
  // loadCalendar = (ind) => {
  //   let buckets = this.state.buckets;
  //   buckets[ind].loading = true;
  //   this.setState({ buckets });
  //   axios.get("/api/user_calendar_invite").then((res) => {
  //     buckets[ind].calls = res.data;
  //     buckets[ind].loading = false;
  //     this.setState({ buckets });
  //   });
  // };
  sendNotification = (bfile) => {
    axios
      .post("/api/get_all_user_for_bad_phone_number_notification", {
        agency_id: bfile.agency_id
      })
      .then((res) => {
        if (res.data.data.length) {
          let data = {
            notification_message: `The phone number for ###${bfile.first_name} ${bfile.last_name}### is not valid. Please update it.`,
            user_ids: res.data.data,
            severity: "low",
            dispatch_time: Math.floor(Date.now() / 1000),
            bfile_id: bfile.id
          };
          axios.post("/api/create_notification", data).then((res) => {
            message.success(F.translate(`Notification Sent Successfully`));
          });
        } else {
          message.info(F.translate(`No Users to Notify`));
        }

        // this.setState({
        //     bad_phone : res.data.data
        // })
      })
      .catch((error) => { });
  };

  loadBucket = (ind, api, filters = [], page) => {
    // F.log("loadBucket calling ind ", ind);
    const { user, period, start_date, end_date, agency_id } = this.state;
    
    this.setState((prevState) => {
      const bucket = prevState.buckets.find(b => b.index === ind);
      const more_filters = bucket ? bucket.filters : {};
      const direction = bucket ? bucket.direction : DESC;
      let order_by = bucket ? bucket.order_by : '';

      // Update order_by if needed
      if (order_by.length === 0 && (ind === 7 || ind === 8)) {
        order_by = "von_appointment_date";
      }

      const newBuckets = prevState.buckets.map((bucket) => {
        if (bucket.index === ind) {
          return {
            ...bucket,
            loading: true,
            order_by
          };
        }
        return bucket;
      });

          return {
        buckets: newBuckets,
        more_filters,
        direction,
        order_by
      };
    }, () => {
      // Use the state values in the callback
      const { more_filters, direction, order_by, buckets } = this.state;
      
      // Rest of the logic that uses these values
      let from = null;
      let to = null;

      // for custom range
      if (start_date != null && end_date != null) {
        from = start_date;
        to = end_date;
      }

      if (period != null && period != "from_to") {
        const datesData = F.getServerDateByType(period);
        from = datesData.from;
        to = datesData.to;
      }

      // if (ind !== 1) {
      if (filters != "") filters = filters + ",";
      filters =
        filters +
        '{"name":"created_on","op":">=","val":"' +
        `${from} 00:00:00` +
        '"},{"name":"created_on","op":"<=","val":"' +
        `${to} 23:59:59` +
        '"}';
      // }

      // if (agency_id) {
      //   more_filters.agency = agency_id;
      // }

      let queries = null;
      if (typeof more_filters.search !== "undefined") {
        queries = F.getQuerySearchFilters(more_filters);
        filters = filters + ',{"or":' + JSON.stringify(queries) + "}";
      }

      filters = F.getDncFilter(filters);

      // if (agency_id) {
      //   filters =
      //     filters + ',{"name":"agency_id","op":"==","val":' + agency_id + "}";
      // } else

      if (more_filters.agency != null && more_filters.agency != "") {
        filters =
          filters +
          ',{"name":"agency_id","op":"==","val":' +
          more_filters.agency +
          "}";
      }

      // let url =
      //   "/api/" +
      //   api +
      //   "?page=" +
      //   page +
      //   '&q={"filters":[' +
      //   filters +
      //   '],"order_by":[{"field":"expiration_date","direction":"asc"}]}';

      // if (ind === 7 || ind === 8) {
      //   url =
      //     "/api/" +
      //     api +
      //     "?page=" +
      //     page +
      //     '&q={"filters":[' +
      //     filters +
      //     '],"order_by":[{"field":"von_appointment_date","direction":"asc"}]}';
      // }

      // NEW
      filters = filters.replace(/\{\}\,/g, '');

      let url =
        "/api/" + api + "?page=" + page + '&q={"filters":[' + filters + "]";

      let orderBy =
        ',"order_by":[{"field":"' + order_by + '","direction":' +
        `"${direction}"` +
        "}]}";


      url = `${url}${orderBy}`;

      // ind === 1 && F.log("index =>", ind, "----", "URL =>", url);

      axios.get(url).then((res) => {
        if (res.data.objects.length > 0)
          ind === 0 && F.log("Response =>", JSON.stringify(res.data));

        let data = [];
        for (let i = 0; i < res.data.objects.length; i++) {
          let bfile = res.data.objects[i];
          let action = null;

          if (ind === 0 || ind === 8) {
            action = (
              <div className="right-align">
                <Button.Group>
                  {/** ====================== Setup Appointment ====================== */}
                  {/* <Button
                    style={{ marginLeft: 10 }}
                    onClick={
                      // () => {}
                      () =>
                        this.setState({
                          setup_appointment_modal: true,
                          bfile
                        })
                    }
                  >
                    <Translate text={`Setup Appointment`} />
                  </Button> */}

                  {/** ====================== Complete/Archive ====================== */}
                  {/* <Button onClick={() => this.complete(ind, bfile.id)}>
                    Complete/Archive
                  </Button> */}

                  {/* <Button onClick={() => this.archive(ind, bfile.id)}>
                    Archive
                  </Button> */}
                  {/* <Button onClick={() => this.complete(ind, bfile)}>
                    Complete
                  </Button> */}

                  {/** ====================== View ====================== */}
                  <Button type="primary" onClick={() => this.view(bfile.id)}>
                    View
                  </Button>
                  {/** ====================== Delete ====================== */}
                  {/* <Popconfirm
                    placement="topRight"
                    title={"Do you really want to delete this B File?"}
                    onConfirm={() => this.delete(ind, bfile.id)}
                    // onConfirm={() => {}}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button>Delete</Button>
                  </Popconfirm> */}
                  {/** ====================== Request New Number ======================*/}
                  <Button
                    // style={{ marginLeft: 10 }}
                    onClick={() => this.sendNotification(bfile)}
                  // onClick={() => {}}
                  >
                    <Translate text={`Request New Number`} />
                  </Button>
                </Button.Group>
              </div>
            );
          } else if (ind === 1 || ind === 4) {
            action = (
              <Button.Group>
                <Button
                  type="primary"
                  onClick={() => this.claim(ind, bfile.id, bfile.expiration_date)}
                >
                  Claim B File
                </Button>
              </Button.Group>
            );
          } else if (ind === 2) {
            action = (
              <Button.Group>
                <Button type="primary" onClick={() => this.view(bfile.id)}>
                  View
                </Button>
                {/* <Button onClick={() => this.archive(ind, bfile.id)}>
                  Archive
                </Button> */}
                <Button onClick={() => this.complete(ind, bfile)}>
                  Complete
                </Button>
              </Button.Group>
            );
          } else {
            action = (
              <Button type="primary" onClick={() => this.view(bfile.id)}>
                View
              </Button>
            );
          }

          data.push({
            key: i,
            name: (
              <div className="autoHandleContentStyle" style={{ width: 150 }}>
                <Link to={"/customer/" + bfile.id}>
                  {bfile.first_name + " " + bfile.last_name}
                </Link>
              </div>
            ),
            phone: (
              <a href={"tel:" + F.phone_format(bfile.phone)}>
                {F.phone_format(bfile.phone)}
              </a>
            ),
            agency: bfile.agency.name,
            type_of_call: bfile.type_of_call,
            sub_type_of_call: (<div style={{ width: 150 }}>
              <Tooltip title={get_label_from_value(bfile.sub_type_of_call, 'label', bfile.type_of_call)}>
                <div style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                  {get_label_from_value(bfile.sub_type_of_call, 'label', bfile.type_of_call)}
                </div>
              </Tooltip>
            </div>),
            // due_date: F.bfile_due_date(bfile, user.default_date, ind, user), // old
            due_date: F.bfile_get_vonboarder_due_date(
              bfile,
              ind,
              user.default_date
            ), // new
            // call_attempts: bfile.attempts,
            call_attempts: F.getCallAttemptsFromBFileQuestionArray(bfile),
            who_created: bfile.user?bfile.user.first_name + " " + bfile.user.last_name:"-",
            action: action,
            rs_effective_date: bfile.rs_effective_date && moment(bfile.rs_effective_date, 'YYYY-MM-DD').format('MM/DD/YYYY') || ""
          });
        }
        // Create a copy of the buckets array
        const updatedBuckets = [...buckets];
        for (let i = 0; i < updatedBuckets.length; i++) {
          if (updatedBuckets[i].index === ind) {
            updatedBuckets[i].loading = false;
            updatedBuckets[i].page = res.data.page;
            updatedBuckets[i].calls = data;
            updatedBuckets[i].total_pages = res.data.total_pages;
            break;
          }
        }

        // Update the state with the modified buckets
        this.setState({ buckets: updatedBuckets });
      });
    });
  };
  claim = (ind, bfile_id, expiration_date) => {
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map((bucket) => {
        if (bucket.index === ind) {
          return {
            ...bucket,
            loading: true
          };
        }
        return bucket;
      });
      return { buckets: newBuckets };
    }, () => {
      axios
        .put("/api/b_file/" + bfile_id, {
          archive: 0,
          not_interested: 0,
          onboarding_id: this.state.user.id,
          expiration_date: expiration_date,
          vo_claim_date: moment(new Date())
            .utc()
            .format("YYYY-MM-DD HH:mm:ss")
        })
        .then(() => {
          this.props.history.push("/customer/" + bfile_id);
          this.refresh();
        });
    });
  };
  archive = (ind, bfile_id) => {
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map((bucket) => {
        if (bucket.index === ind) {
          return {
            ...bucket,
            loading: true
          };
        }
        return bucket;
      });
      return { buckets: newBuckets };
    }, () => {
      axios
        .put("/api/b_file/" + bfile_id, {
          vob_archived: 1
        })
        .then(() => {
          this.loadBuckets(ind, 1);
        });
    });
  };
  complete = (ind, bfile) => {
    const { user } = this.state;
    const bfile_id = bfile.id;

    // Update loading state using prevState
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map((bucket) => {
        if (bucket.index === ind) {
          return {
            ...bucket,
            loading: true
          };
        }
        return bucket;
      });
      return { buckets: newBuckets };
    }, () => {
      // Send to `Not Interested`
      const notInterestedPayload = {
        vob_archived: 1
      };

      // Make API calls
      Promise.all([
        axios.put("/api/b_file/" + bfile_id, notInterestedPayload),
        axios.post("/api/bfile_notes", {
          bfile_id: bfile.id,
          note: "Not interested.",
          user_id: user.id,
          action: "Complete"
        })
      ]).then(() => {
        // Reload buckets after completion
        this.loadBuckets(ind, 1);
      });
    });
  };
  delete = (ind, bfile_id) => {
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map((bucket) => {
        if (bucket.index === ind) {
          return {
            ...bucket,
            loading: true
          };
        }
        return bucket;
      });
      return { buckets: newBuckets };
    }, () => {
      axios
        .put("/api/b_file/" + bfile_id, {
          deleted: 1
        })
        .then(() => {
          this.loadBuckets(ind, 1);
        });
    });
  };
  view = (bfile_id) => {
    this.props.history.push("/customer/" + bfile_id);
  };

  // updateExpandState = (i) => {
  //   const newBucketsToggle = [...this.state.bucketsToggle];
  //   newBucketsToggle[i].expandStats = !newBucketsToggle[i].expandStats;
  //   this.setState({ bucketsToggle: newBucketsToggle });
  // };

  onSelectAgency = (agency_id) => {
    this.setState((prevState) => {
      const newBuckets = prevState.buckets.map((bucket) => {
        return {
          ...bucket,
          filters: {
            ...bucket.filters,
            agency: agency_id
          }
        };
      });
      return { buckets: newBuckets };
    }, () => {
      this.loadStats();
      this.loadBuckets("all", 1);
    });
  };

  saveSortingDirectionInLocalStorage = (ind, direction) => {
    // get existing `sorting direction` object from local storage
    const sorting_direction =
      "sorting_direction" in window.localStorage
        ? JSON.parse(window.localStorage.sorting_direction)
        : {};

    // update direction by `index`
    sorting_direction[ind] = direction;

    // update in local storage
    window.localStorage.sorting_direction = JSON.stringify(sorting_direction);
  };


  onSearchAgency = (index, value) => {
    this.setState(
      {
        search: value,
      },
      () => debounceQuery(this.search(index, value))
    );
  };

  render() {
    const {
      start_date,
      end_date,
      period,
      user,
      loading,
      buckets,
      agencies,
      stats,
      stats_loading,
      typeOfCall,
      dedicated_agency_modal,
      agency_id
    } = this.state;

    // const dateFormat = "MM/DD/YYYY";
    const dateFormat = "YYYY-MM-DD";

    let defaultFromDate = new Date("2010-01-01");
    if (start_date) defaultFromDate = new Date(start_date);

    let defaultToDate = new Date("2050-01-01");
    if (end_date) defaultToDate = new Date(end_date);

    return (
      <div>
        <div className="topbar">
          <Card bordered={false}>
            <Row gutter={16} type="flex" justify="space-around" align="middle">
              <Col md={8} span={24}>
                <div className="username">
                  <Icon type="user" />
                  {user.first_name + " " + user.last_name}{" "}
                  <Tag color="blue">{user.user_type === "VONBOARDER" ? "Follow Up Specialist" : user.user_type}</Tag>
                </div>
              </Col>
              <Col md={16} span={24}>
                <div
                  className="right-align"
                  style={{ marginTop: -5, marginBottom: -5 }}
                >
                  <div className="inlineField">
                    <Radio.Group
                      value={typeOfCall}
                      onChange={this.handleTypeOfCall.bind(this)}
                      style={{ width: "100%" }}
                    >
                      <Radio.Button value="followup ">
                        <Translate text={`Opportunity`} />
                      </Radio.Button>
                      <Radio.Button value="prospect">
                        <Translate text={`Lead`} />
                      </Radio.Button>
                    </Radio.Group>
                  </div>
                  <div className="inlineField">
                    <Button icon="reload" onClick={this.refresh.bind(this)}>
                      {" "}
                      <Translate text={`Refresh`} />
                    </Button>
                  </div>
                  <div className="inlineField">
                    <Radio.Group
                      value={period}
                      onChange={this.changePeriod.bind(this)}
                      style={{ width: "100%" }}
                    >
                      <Radio.Button value="mtd">
                        <Translate text={`This Month`} />
                      </Radio.Button>
                      <Radio.Button value="all_bfiles">
                        <Translate text={`All B Files`} />
                      </Radio.Button>
                    </Radio.Group>
                  </div>
                  <div className="inlineField">
                    <RangePicker
                      value={[moment(defaultFromDate), moment(defaultToDate)]}
                      onChange={this.onChangeDateRange}
                      format={dateFormat}
                      style={{ maxWidth: 280 }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        </div>
        <Spin indicator={antIcon} spinning={loading}>
          {buckets.map((bucket, i) => {


            let conditionalDate = []

            if ([7, 8].includes(bucket.index)) {
              conditionalDate = [
                {
                  title: "Appointment Date",
                  dataIndex: "due_date",
                  key: "due_date",
                  width: 160,
                  sortOrder:
                    bucket.direction === DESC
                      ? SORT_ORDER_DESCEND
                      : SORT_ORDER_ASCEND,
                  onHeaderCell: () => {
                    return {
                      onClick: () => {
                        this.setState((prevState) => {
                          const newBuckets = prevState.buckets.map((bucket, idx) => {
                            if (idx === i) {
                              const newDirection = bucket.direction === DESC ? ASC : DESC;
                              // Save sorting direction in local storage
                              this.saveSortingDirectionInLocalStorage(bucket.index, newDirection);
                              
                    return {
                                ...bucket,
                                direction: newDirection,
                                order_by: "von_appointment_date"
                              };
                            }
                            return bucket;
                          });
                          return { buckets: newBuckets };
                        }, () => {
                          this.loadBuckets(bucket.index, 1);
                        });
                    }
                  };
                },
                sorter: true
                }
              ]
            } else {
              conditionalDate = [
                {
                  title: "Active Call Date",
                  dataIndex: "rs_effective_date",
                  key: "rs_effective_date",
                  width: 140,
                  sortOrder:
                    bucket.direction === DESC
                      ? SORT_ORDER_DESCEND
                      : SORT_ORDER_ASCEND,
                  onHeaderCell: () => {
                    return {
                      onClick: () => {
                        this.setState((prevState) => {
                          const newBuckets = prevState.buckets.map((bucket, idx) => {
                            if (idx === i) {
                              const newDirection = bucket.direction === DESC ? ASC : DESC;
                              // Save sorting direction in local storage
                              this.saveSortingDirectionInLocalStorage(bucket.index, newDirection);
                              
                              return {
                                ...bucket,
                                direction: newDirection,
                                order_by: "rs_effective_date"
                              };
                            }
                            return bucket;
                          });
                          return { buckets: newBuckets };
                        }, () => {
                          this.loadBuckets(bucket.index, 1);
                        });
                      }
                    };
                  },
                  sorter: true
                },
                {
                  title: "Schedule By Date",
                  dataIndex: "due_date",
                  key: "due_date",
                  width: 150,
                  sortOrder:
                    bucket.direction === DESC
                      ? SORT_ORDER_DESCEND
                      : SORT_ORDER_ASCEND,
                  onHeaderCell: () => {
                    return {
                      onClick: () => {
                        this.setState((prevState) => {
                          const newBuckets = prevState.buckets.map((bucket, idx) => {
                            if (idx === i) {
                              const newDirection = bucket.direction === DESC ? ASC : DESC;
                              // Save sorting direction in local storage
                              this.saveSortingDirectionInLocalStorage(bucket.index, newDirection);
                              
                              return {
                                ...bucket,
                                direction: newDirection,
                                order_by: "expiration_date"
                              };
                            }
                            return bucket;
                          });
                          return { buckets: newBuckets };
                        }, () => {
                          this.loadBuckets(bucket.index, 1);
                        });
                      }
                    };
                  },
                  sorter: true
                }
              ]
            }


            // if (bucket.title === "Calendar Invites") {
            //   return (
            //     <Card
            //       key={i}
            //       type="inner"
            //       className="tableCard"
            //       title={
            //         <div style={{ paddingTop: 7 }}>
            //           <Icon
            //             type="folder"
            //             style={{ marginRight: 10, color: "#1890ff" }}
            //           />
            //           {bucket.title}
            //         </div>
            //       }
            //       loading={bucket.loading}
            //       style={{ marginBottom: 20 }}
            //     >
            //       <div style={{ padding: "25px" }}>
            //         <Timeline>
            //           {bucket.calls.map((item, i) => (
            //             <Timeline.Item key={i}>
            //               <div>
            //                 <Link
            //                   to={"/customer/" + item.bfile_id}
            //                   className="invite"
            //                 >
            //                   {item.customer_name}
            //                 </Link>
            //               </div>
            //               <div className="date">
            //                 <Translate text={`Date`} />:{" "}
            //                 {moment(new Date(item.date)).format(
            //                   "MM/DD/YYYY hh:mmA"
            //                 )}
            //               </div>
            //               <div className="agency">
            //                 <Translate text={`Agency`} />: {item.agency_name}
            //               </div>
            //             </Timeline.Item>
            //           ))}
            //           {bucket.calls.length === 0 ? (
            //             <div className="notfound">
            //               <Translate text={`No Invites Found`} />
            //             </div>
            //           ) : null}
            //         </Timeline>
            //       </div>
            //     </Card>
            //   );
            // }

            let columns = [
              {
                title: "Name",
                dataIndex: "name",
                key: "name",
                sortOrder:
                  bucket.direction === DESC
                    ? SORT_ORDER_DESCEND
                    : SORT_ORDER_ASCEND,
                onHeaderCell: () => {
                  return {
                    onClick: () => {
                      this.setState((prevState) => {
                        const newBuckets = prevState.buckets.map((bucket, idx) => {
                          if (idx === i) {
                            const newDirection = bucket.direction === DESC ? ASC : DESC;
                            // Save sorting direction in local storage
                            this.saveSortingDirectionInLocalStorage(bucket.index, newDirection);
                            
                            return {
                              ...bucket,
                              direction: newDirection,
                              order_by: 'first_name'
                            };
                          }
                          return bucket;
                        });
                        return { buckets: newBuckets };
                      }, () => {
                        this.loadBuckets(bucket.index, 1);
                      });
                    }
                  };
                },
                sorter: true
              },
              {
                title: "Phone",
                dataIndex: "phone",
                key: "phone"
              },
              {
                title: "Agency",
                dataIndex: "agency",
                key: "agency"
              },
              {
                title: <Translate text={`type_of_call`} />,
                dataIndex: "type_of_call",
                key: "type_of_call",
                width: 120,
                sortOrder:
                  bucket.direction === DESC
                    ? SORT_ORDER_DESCEND
                    : SORT_ORDER_ASCEND,
                onHeaderCell: () => {
                  return {
                    onClick: () => {
                      this.setState((prevState) => {
                        const newBuckets = prevState.buckets.map((bucket, idx) => {
                          if (idx === i) {
                            const newDirection = bucket.direction === DESC ? ASC : DESC;
                            // Save sorting direction in local storage
                            this.saveSortingDirectionInLocalStorage(bucket.index, newDirection);
                            
                            return {
                              ...bucket,
                              direction: newDirection,
                              order_by: 'type_of_call'
                            };
                          }
                          return bucket;
                        });
                        return { buckets: newBuckets };
                      }, () => {
                        this.loadBuckets(bucket.index, 1);
                      });
                    }
                  };
                },
                sorter: true

              },
              {
                title: <Translate text={`sub_type_of_call`} />,
                dataIndex: "sub_type_of_call",
                key: "sub_type_of_call",
                sortOrder:
                  bucket.direction === DESC
                    ? SORT_ORDER_DESCEND
                    : SORT_ORDER_ASCEND,
                onHeaderCell: () => {
                  return {
                    onClick: () => {
                      this.setState((prevState) => {
                        const newBuckets = prevState.buckets.map((bucket, idx) => {
                          if (idx === i) {
                            const newDirection = bucket.direction === DESC ? ASC : DESC;
                            // Save sorting direction in local storage
                            this.saveSortingDirectionInLocalStorage(bucket.index, newDirection);
                            
                            return {
                              ...bucket,
                              direction: newDirection,
                              order_by: 'sub_type_of_call'
                            };
                          }
                          return bucket;
                        });
                        return { buckets: newBuckets };
                      }, () => {
                        this.loadBuckets(bucket.index, 1);
                      });
                    }
                  };
                },
                sorter: true
              },
              ...conditionalDate,
              // {
              //   title: "Due Date",
              //   dataIndex: "due_date",
              //   key: "due_date",

              //   sortOrder:
              //     bucket.direction === DESC
              //       ? SORT_ORDER_DESCEND
              //       : SORT_ORDER_ASCEND,
              //   onHeaderCell: () => {
              //     return {
              //       onClick: () => {
              //         if (bucket.direction === DESC) {
              //           const newBuckets = [...this.state.buckets];
              //           newBuckets[i].direction = ASC;
              //           newBuckets[i].order_by = [7,8].includes(bucket.index) ? "von_appointment_date" : "expiration_date";

              //           // saveSortingDirectionInLocalStorage
              //           this.saveSortingDirectionInLocalStorage(
              //             bucket.index,
              //             ASC
              //           );

              //           this.setState({ buckets: newBuckets }, () => {
              //             this.loadBuckets(bucket.index, 1);
              //           });
              //         } else {
              //           const newBuckets = [...this.state.buckets];
              //           newBuckets[i].direction = DESC;
              //           newBuckets[i].order_by =[7,8].includes(bucket.index) ? "von_appointment_date" : "expiration_date";

              //           // saveSortingDirectionInLocalStorage
              //           this.saveSortingDirectionInLocalStorage(
              //             bucket.index,
              //             DESC
              //           );

              //           this.setState({ buckets: newBuckets }, () => {
              //             this.loadBuckets(bucket.index, 1);
              //           });
              //         }
              //       }
              //     };
              //   },
              //   sorter: true
              // },
              {
                title: "Call Attempts",
                dataIndex: "call_attempts",
                key: "call_attempts",
                width: 130,
                sortOrder:
                  bucket.direction === DESC
                    ? SORT_ORDER_DESCEND
                    : SORT_ORDER_ASCEND,
                onHeaderCell: () => {
                  return {
                    onClick: () => {
                      this.setState((prevState) => {
                        const newBuckets = prevState.buckets.map((bucket, idx) => {
                          if (idx === i) {
                            const newDirection = bucket.direction === DESC ? ASC : DESC;
                            // Save sorting direction in local storage
                            this.saveSortingDirectionInLocalStorage(bucket.index, newDirection);
                            
                            return {
                              ...bucket,
                              direction: newDirection,
                              order_by: "attempts"
                            };
                          }
                          return bucket;
                        });
                        return { buckets: newBuckets };
                      }, () => {
                        this.loadBuckets(bucket.index, 1);
                      });
                    }
                  };
                },
                sorter: true

              },
              {
                title: "Who Created",
                dataIndex: "who_created",
                key: "who_created"
              },
              {
                title: "Action",
                dataIndex: "action",
                key: "action"
              }
            ];

            return (
              <Card
                key={i}
                type="inner"
                className="tableCard"
                title={
                  <div style={{ paddingTop: 7 }}>
                    <Icon
                      type="folder"
                      style={{ marginRight: 10, color: "#1890ff" }}
                    />
                    {bucket.title}
                  </div>
                }
                loading={bucket.loading}
                style={{ marginBottom: 20 }}
                // extra={
                //   this.state.bucketsToggle[i].expandStats ? (
                //     <Row
                //       gutter={16}
                //       style={{ maxWidth: 600 }}
                //       type="flex"
                //       justify="end"
                //     >
                //       <Col md={14} span={24}>
                //         <Input
                //           prefix={<Icon type="search" />}
                //           placeholder="Search..."
                //           onPressEnter={(e) => {
                //             this.search(bucket.index, e.target.value);
                //           }}
                //         />
                //       </Col>
                //       {!agency_id ? (
                //         <Col md={10} span={24}>
                //           <Select
                //             value={bucket.filters.agency}
                //             style={{ width: "100%" }}
                //             onChange={(val) => {
                //               this.agencyChange(bucket.index, val);
                //             }}
                //           >
                //             <Option value={""}>{"Filter by Agency"}</Option>
                //             {agencies.map((agency, i) => (
                //               <Option key={i} value={agency.id + ""}>
                //                 {agency.name}
                //               </Option>
                //             ))}
                //           </Select>
                //         </Col>
                //       ) : null}
                //       {/* <Col md={10} span={24}>
                //       <Select
                //         value={bucket.filters.agency}
                //         style={{ width: "100%" }}
                //         onChange={(val) => {
                //           this.agencyChange(bucket.index, val);
                //         }}
                //       >
                //         <Option value={""}>{"Filter by Agency"}</Option>
                //         {agencies.map((agency, i) => (
                //           <Option key={i} value={agency.id + ""}>
                //             {agency.name}
                //           </Option>
                //         ))}
                //       </Select>
                //     </Col> */}
                //     </Row>
                //   ) : null
                // }
                extra={
                  <Row
                    gutter={16}
                    style={{ maxWidth: 600 }}
                    type="flex"
                    justify="end"
                  >
                    <Col md={14} span={24}>
                      <Input
                        prefix={<Icon type="search" />}
                        // onChange={(e) => this.onSearchAgency(bucket.index, e.target.value)}
                        // value={this.state.search}
                        placeholder="Search..."
                        onPressEnter={(e) => {
                          const searchPurify = F.removeSpecialCharactersFromString(
                            e.target.value
                          );

                          if (searchPurify.trim().length > 0) {
                            this.search(bucket.index, searchPurify);
                          }
                        }}
                      />
                    </Col>
                    {/* {!agency_id ? (
                      <Col md={10} span={24}>
                        <Select
                          value={bucket.filters.agency}
                          style={{ width: "100%" }}
                          onChange={(val) => {
                            this.agencyChange(bucket.index, val);
                          }}
                        >
                          <Option value={""}>{"Filter by Agency"}</Option>
                          {agencies.map((agency, i) => (
                            <Option key={i} value={agency.id}>
                              {agency.name}
                            </Option>
                          ))}
                        </Select>
                      </Col>
                    ) : null} */}
                    <Col md={10} span={24}>
                      <Select
                        value={bucket.filters.agency}
                        style={{ width: "100%" }}
                        onChange={(val) => {
                          this.agencyChange(bucket.index, val);
                        }}
                      >
                        <Option value={""}>{"Filter by Agency"}</Option>
                        {agencies.map((agency, i) => (
                          <Option key={i} value={+agency.id}>
                            {agency.name}
                          </Option>
                        ))}
                      </Select>
                    </Col>
                  </Row>
                }
              >
                {/* <Collapse expandStats={this.state.bucketsToggle[i].expandStats}>
                  <Table
                    columns={columns}
                    dataSource={bucket.calls}
                    bordered={false}
                    pagination={false}
                  />
                  {!bucket.loading ? (
                    <Pagination
                      current_page={bucket.page}
                      total_pages={bucket.total_pages}
                      onClick={(page) => {
                        this.loadBuckets(bucket.index, page);
                      }}
                    />
                  ) : null}
                </Collapse> */}
                <Table
                  columns={columns}
                  dataSource={bucket.calls}
                  bordered={false}
                  pagination={false}
                  locale={{ emptyText: "No Data To Show" }}
                />
                {!bucket.loading ? (
                  <Pagination
                    current_page={bucket.page}
                    total_pages={bucket.total_pages}
                    onClick={(page) => {
                      this.loadBuckets(bucket.index, page);
                    }}
                  />
                ) : null}
                {/* {bucket.calls.length > 0 && (
                  <ShowHideStats
                    expandStats={this.state.bucketsToggle[i].expandStats}
                    updateExpandState={() => this.updateExpandState(i)}
                    applyParentDivOnShowStatsButton={true}
                  />
                )} */}
              </Card>
            );
          })}
        </Spin>

        <Stats
          stats={stats}
          loading={stats_loading}
          user={user}
          start_date={start_date}
          end_date={end_date}
          period={period}
          history={this.props.history}
        />

        <AgencyModal
          history={this.props.history}
          showModal={dedicated_agency_modal}
          // reset={() => {
          //   this.setState({ agency_id: null }, () => {
          //     this.loadBuckets("all", 1);
          //     this.loadStats();
          //   });
          // }}
          hideModal={() => {
            this.setState({ dedicated_agency_modal: false });
            this.props.history.replace("/dashboard");
          }}
          onSelectAgency={this.onSelectAgency}
        />
        {this.state.setup_appointment_modal && this.state.bfile ? (
          <SetupAppointment
            history={this.props.history}
            showModal={this.state.setup_appointment_modal}
            hideModal={() => this.setState({ setup_appointment_modal: false })}
            bfile={this.state.bfile}
            user={user}
            refresh={this.refresh}
            {...this.props}
          />
        ) : null}
      </div>
    );
  }
}

export default Vonboard;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/vonboard-back.js